import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots } from 'vue'

import LPopover from '@/components/core/Popover.vue'

interface DatePickerProps {
  value: string[] | string | undefined
  open?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    value: null,
    open: { type: Boolean }
  },
  emits: ["input", "update:open"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string[] | string | undefined): void
  (e: 'update:open', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string[] | string | undefined
  open?: boolean
};





const slots = useSlots()

const date = computed({
  get() {
    return props.value
  },
  set(value) {
    if (Array.isArray(value) && value.length === 2) {
      if (value[0] > value[1]) {
        const tmp = value[0]
        value[0] = value[1]
        value[1] = tmp
      }
    }
    emit('input', value)
    if ((Array.isArray(value) && value.length !== 2) || slots.footer) {
      return
    }
    isOpen.value = false
  },
})

const internalIsOpen = ref(false)
const isOpen = computed({
  get() {
    return props.open !== undefined ? props.open : internalIsOpen.value
  },
  set(value) {
    internalIsOpen.value = value
    emit('update:open', value)
  },
})

function clearDate() {
  if (Array.isArray(date.value)) {
    date.value = []
  } else {
    date.value = ''
  }
  isOpen.value = false
}

return { __sfc: true,props, emit, slots, date, internalIsOpen, isOpen, clearDate, LPopover }
}

})